export default "__VITE_ASSET__c8068032__"